export default {
    namespaced: true,
    state: {
        department: 0,
        departments: ['tryg', 'alka', 'none'],
        levels: {
            tryg: [5, 4, 3, 2, 1, 0],
            alka: [4, 3, 2, 1, 0],
            none: [0]
        },
        searchString: null
    },
    getters: {
        levels (state, getters) {
            return state.levels[getters['department']]
        },
        department (state) {
            return state.departments[state.department]
        },
        control (state) {
            return state.controls[state.control]
        }
    }
}